import React from 'react';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import 'bootstrap-icons/font/bootstrap-icons.css';
import LandingPage from '../LandingPage/LandingPage';
import * as Icon from "react-bootstrap-icons";
import { Button } from 'primereact/button';

const Whoweare = () => {
  return (
    <>
      {/* Who We Are Section */}

      <div className="container py-5 who-we-are">
        <div className="row align-items-start">
          {/* Left Section */}
          <div className="col-12 col-lg-4 d-flex flex-column gap-3">
            <div>
              <span className="text-muted text-highlight">
                Who we are
              </span>
            </div>
            <h2 className="tx-36 _500 text-normal">
             Premium Relocation offers pre-made relocation services designed for expatriates.

            </h2>

            <p className="lead tx-16 1h-base">
              Premium relocation services tailored for expatriates and domestic.
IOS Relocation offers premium relocation services designed for both expatriates and domestic moves. We specialize in creating smooth, stress-free transitions tailored to individual needs, including securing accommodations. Our mission is to provide peace of mind and a seamless experience, wherever life takes you.
            </p>

            <div className='form-group'><Button className="btn-landing">Learn more</Button></div>
          </div>

          {/* Right Section */}
          <div className="col-12 col-lg-8 d-flex flex-column gap-3 ">
            <figure className="image-anime   " >
              <img src="/Images/work1.jpg" alt="Team Discussion" />
            </figure>

            <div className="row g-3">
              {/* Vision Card */}
              <div className="col-12 col-md-6">
                <div className="p-4 rounded   h-100 text-start card vision-card">
                  <div className="d-flex align-items-center mb-2">
                    <div className="icon-box">
                      <Icon.EyeFill   className="icon-svg"/>
                    </div>
                   
                    <h5 className="_600 mb-0 text-start">Our Vision</h5>
                  </div>
                  <p className="mb-0 text-start">
                    We aim to transcend boundaries and shape the future of relocation as a global leader. By embracing innovation and growth, we remain committed to personalized care, integrity, and excellence in every move.
                  </p>
                </div>
              </div>

              {/* Mission Card */}
              <div className="col-12 col-md-6">
                <div className="p-4 rounded   h-100 text-start card mission-card" >
                  <div className="d-flex align-items-center mb-2">
                    <div className="icon-box">
                      <Icon.FlagFill  className="icon-svg"/>
                    </div>
                    <h5 className="fw-bold mb-0 text-start">Our Mission</h5>
                  </div>
                  <p className="mb-0 text-start">
                    At IOS Relocation, we redefine relocation through excellence, empathy, and innovation, combining technology, expertise, and personalized care to make every move seamless and stress-free.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div></>
  );
};

export default Whoweare;